import { render, staticRenderFns } from "./return.vue?vue&type=template&id=7812b6ea&scoped=true&"
import script from "./return.vue?vue&type=script&lang=js&"
export * from "./return.vue?vue&type=script&lang=js&"
import style0 from "./return.vue?vue&type=style&index=0&lang=css&"
import style1 from "./return.vue?vue&type=style&index=1&id=7812b6ea&scoped=true&lang=css&"
import style2 from "./return.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7812b6ea",
  null
  
)

export default component.exports